<template>
  <div class="form-group">
    <label :for="valueKey">
      {{ label }}
      <validation-message
        :required="required"
        :invalid="invalid"
        :errorMessage="errorMessage"
      />
    </label>
    <password-input
      v-if="type == 'password' && valueKey != 'ssn'"
      :modifier="modifier"
      :type="type"
      :id="valueKey"
      :name="valueKey"
      v-model="internalValue"
      @focus="onFocus"
      :disabled="disabled ? 'disabled' : null"
      :required="required"
      :pattern="pattern"
    />
    <ssn-input
      v-else-if="valueKey == 'ssn'"
      :name="valueKey"
      :id="valueKey"
      :modifier="modifier"
      v-model.trim="internalValue"
      @focus="onFocus"
      :disabled="disabled ? 'disabled' : null"
      :required="required"
    />
    <textarea v-else-if="type == 'textarea'"
      :class="modifier"
      :type="type"
      :id="valueKey"
      :maxlength="maxlength"
      :placeholder="placeholder"
      v-model.trim="internalValue"
      @focus="onFocus"
      @blur="onBlur"
      :name="valueKey"
      :disabled="disabled ? 'disabled' : null"
      :required="required"
      :pattern="pattern"></textarea>
    <div v-else class="_flex">
      <slot></slot>
      <input
      :autocomplete="autocomplete ? 'on' : 'off'"
      :class="modifier"
      :type="type"
      :id="valueKey"
      :maxlength="maxlength"
      :placeholder="placeholder"
      v-model.trim="internalValue"
      @focus="onFocus"
      @blur="onBlur"
      :name="valueKey"
      :disabled="disabled ? 'disabled' : null"
      :required="required"
      :pattern="pattern"
      :readonly="readonly"
      :min="min"
    />
    </div>
   
  </div>
</template>

<script>
  import ValueInputBindings from '@mixins/ValueInputBindings'
  import ValidationMessage from '@atoms/ValidationMessage'
  import PasswordInput from '@atoms/PasswordInput.vue'
  import SsnInput from '@atoms/SsnInput.vue'

  export default {
    mixins: [ValueInputBindings],
    components: { ValidationMessage, PasswordInput, SsnInput },
    props: {
      autocomplete: {
        type: Boolean,
        default: false
      },
      modifier: {
        type: String,
        default: 'form-input'
      },
      pattern: {
        type: String,
        default: null
      },
      type: {
        type: String,
        default: 'text'
      },
      required: {
        type: Boolean,
        default: false
      },
      label: String,
      placeholder: String,
      value: [Number, String, Date],
      valueKey: String,
      maxlength: String,
      disabled: Boolean,
      readonly: Boolean,
      onFocus: {
        type: Function,
        default() {}
      },
      onBlur: {
        type: Function,
        default() {}
      },
      invalid: {
        type: Boolean,
        default: false
      },
      errorMessage: {
        type: String,
        default: ''
      },
      min: {
        type: Number
      }
    }
  }
</script>
